import { User } from "../../../../models/user";
import { SignupRepository } from "../../infra/repository/signup.repository";

export class SignupUseCase {
    static async execute(
        user: User,
        token: string,
        planId?: string,
    ): Promise<boolean> {
        try {
            console.log(`token: ${token}`)
            const response = await SignupRepository.createUser(user, token, planId);
            if (response.error) return false;
            return true;
        } catch (error) {
            return false;
        }

    }

}
